module.exports = __webpack_public_path__ + "images/d8bf5c3ca8891b26bb53de007830646e.png";